import React from 'react';
import { Button, Tooltip, Tag, Table, Empty} from 'antd';
import global from '../../../common/utility/global';


export default function ResultList(props) {
    return (

    <Table
    bordered={props.bordered === undefined ? false : props.bordered}
    style={{ overflowX: 'auto',whiteSpace:'nowrap' }}
    title={() => (
        <div style={{ width: '100%', textAlign: "right" }}>
            <div className="custom-options">
                {
                    props.onExportExcel === undefined ? null :
                        <Button ghost
                            type="success"
                            icon="file-excel"
                            onClick={props.onExportExcel}
                            style={{ color: '#3fb703' }}
                            loading={props.loadingExcel}
                        >
                            Excel
                        </Button>
                }
                {
                    props.onExportPdf === undefined ? null :
                        <Button ghost
                            type="danger"
                            icon="file-pdf"
                            onClick={props.onExportPdf}
                            style={{ color: '#ff4d4f' }}
                            loading={props.loadingPdf}
                            hidden={true}
                        >
                            Pdf
                        </Button>
                }
          
            </div>
        </div>
    )}


    loading={
        props.pagination.loading ? {
            tip: "Un momento por favor",
            size: "large"
        } : false
    }
    size="small"
    rowKey={record => record.uid}
    dataSource={props.pagination.data}
    onChange={(pagination, filters, sorter) => {
        props.onChange({
            page: pagination.current,
            order: sorter.order,
            field: sorter.field
        })
    }}

    locale={{
        emptyText: <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No se encontraron datos."
        />
    }}
    pagination={{
        total: props.pagination.total,
        current: props.pagination.page,
        pageSize: props.pagination.pageSize,
        showTotal: (total) => `${total} Registro(s) encontrado(s).`
    }}

    columns={[
        {
            title: 'Fecha Comprobante',
            dataIndex: 'fechaStr',
            key: 'fecha',
            sorter: true
        },
        {
            title: 'Nro Comprobante',
            dataIndex: 'serieDocumentoComprobante',
            key: 'comprobante',
            sorter: true
        },
        {
            title: 'Tipo Comprobante',
            dataIndex: 'nombreTipoComprobante',
            key: 'tipoComprobante',
            sorter: true
        },
        {
            title: 'Fecha Vencimiento',
            dataIndex: 'fechaVencimiento',
            key: 'fechaVencimiento',
        },
        {
            title: 'Tipo Documento',
            dataIndex: 'tipoDocumentoCliente',
            key: 'tipoDocumentoCliente',
            sorter: true
        },
        {
            title: 'Nro Documento',
            dataIndex: 'numeroDocumentoCliente',
            key: 'numeroDocumentoCliente',
            sorter: true
        },
        {
            title: 'Cliente',
            dataIndex: 'razonSocialCliente',
            key: 'razonSocialCliente',
            sorter: true
        },
        {
            title: 'Cuota',
            dataIndex: 'couta',
            key: 'couta',
            sorter: true
        },
    
   
        {
            title: 'Moneda Original',
            dataIndex: 'moneda',
            key: 'moneda',
            sorter: true
        },


        {
            title: 'Importe Cuota',
            dataIndex: 'totalSoles',
            key: 'totalSoles',
            align: 'right',
             render: (data) => (
                <span>{data.toFixed(2)}</span>
            ) 
        },
        {
            title: 'Tipo Cambio',
            dataIndex: 'tipoCambio',
            key: 'tipoCambio',
            render: (data) => (
                <span>{data.toFixed(3)}</span>
            )
        },

        {
            title: 'Fecha Pago',
            dataIndex: 'fechaPago',
            key: 'fechaPago'
    
        },
        {
            title: 'Cobrado',
            className: 'parent-group parent-group-2',
            children: [
                {
                    title: 'Soles',
                    dataIndex: 'canceladoSoles',
                    key: 'canceladoSoles',
                    className: 'parent-group parent-group-2',

                    align: 'right',
                     render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    ) 
                },
                {
                    title: 'Dólares',
                    dataIndex: 'canceladoDolares',
                    key: 'canceladoDolares',
                    className: 'parent-group parent-group-2',

                    align: 'right',
                     render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    ) 
                }
            ]
        },
     

     
   
        {
            title: 'Metodo Pago',
            dataIndex: 'metodoPago',
            key: 'metodoPago'
          
        },
        {
            title: 'Banco',
            dataIndex: 'banco',
            key: 'banco'
          
        },
        {
            title: 'Nro Cuenta',
            dataIndex: 'cuenta',
            key: 'cuenta'
          
        },
        {
            title: 'Nro Operacion',
            dataIndex: 'nroOperacion',
            key: 'nroOperacion'
          
        },
        {
            title: 'Nro Doc. Referencia',
            dataIndex: 'referencia',
            key: 'referencia'
          
        }
 
    ]}
/>
    );
}